import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const listItemConfig = {
transform(props) {
  const { disablePadding, ...rest } = props;
  return {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    textDecoration: "none",
    width: "[100%]",
    boxSizing: "border-box",
    textAlign: "left",
    ...disablePadding ? {} : { py: "2", px: "3" },
    ...rest
  };
},
defaultValues:{disablePadding:false}}

export const getListItemStyle = (styles = {}) => {
  const _styles = getPatternStyles(listItemConfig, styles)
  return listItemConfig.transform(_styles, patternFns)
}

export const listItem = (styles) => css(getListItemStyle(styles))
listItem.raw = getListItemStyle